import { Component, OnInit, Input } from '@angular/core';
import { Product } from 'src/app/models/interface/product/product';
import * as moment from 'moment';
import { Cfs } from 'src/app/models/interface/product/cfs';
import { Role } from 'src/app/utils/Role';
import { ProductService } from 'src/app/services/api/product/product.service';

@Component({
  selector: 'app-product-map-info',
  templateUrl: './product-map-info.component.html',
  styleUrls: ['./product-map-info.component.scss']
})
export class ProductMapInfoComponent implements OnInit {

  private _item: Product;
  @Input()
  get item(): any {
    return this._item;
  }
  set item(value: any) {
    this._item = value;
    if (this.info) {
      if (!this._params.type || this._params.type === 'product') {
        this.info.productState = this._item.productState;
      }
    }
    else {
      if (this._params) {
        this.ngOnInit();
      }
    }
  }

  @Input() isps: any[];

  private _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    if (this._item) {
      this.ngOnInit();
    }
  }

  type: string;
  info: any;

  constructor(private productService: ProductService) {

  }

  async ngOnInit() {

    this.type = !this.params.type ? 'product' : this.params.type;
    let serviceInfo: any;

    if (this.type === 'cfs') {
      serviceInfo = this.item.cfses.find(service => service.id === +this.params.map);
    }
    if (this.type === 'rfs') {
      for (const cfs of this.item.cfses) {
        if (cfs.rfses.find(service => service.id === +this.params.map)) {
          serviceInfo = cfs.rfses.find(service => service.id === +this.params.map);
          break;
        }
      }
    }

    switch (this.type) {
      case 'product':
        this.info = {
          specId: this.item.specId,
          domainName: this.item.domainName,
          id: this.item.id,
          ispCode: this.item.origin,
          ispName: this.isps.find(ispAux => ispAux.code === this.item.origin && ispAux.reseller === ispAux.name) ? this.isps.find(ispAux => ispAux.code === this.item.origin && ispAux.reseller === ispAux.name).name : null,
          productState: this.item.productState,
          createdAt: this.item.createdAt ? moment(this.item.createdAt).locale('es').format('LLL') : null,
          terminationDate: this.item.terminationDate ? moment(this.item.terminationDate).locale('es').format('LLL') : null,
        };
        break;
      case 'cfs':
        this.info = {
          serviceSpecId: serviceInfo.specId,
          serviceId: serviceInfo.serviceId,
          serviceState: serviceInfo.serviceState,
          searchKey: serviceInfo.searchKey,
          operationalState: serviceInfo.operationalState,

          createdAt: serviceInfo.createdAt ? moment(serviceInfo.createdAt).locale('es').format('LLL') : null,
          readyForService: serviceInfo.readyForService ? moment(serviceInfo.readyForService).locale('es').format('LLL') : null,
          readyForBilling: serviceInfo.readyForBilling ? moment(serviceInfo.readyForBilling).locale('es').format('LLL') : null,
          disconnectDate: serviceInfo.disconnectDate ? moment(serviceInfo.disconnectDate).locale('es').format('LLL') : null
        };
        break;
      case 'rfs':
        this.info = {
          serviceSpecId: serviceInfo.specId,
          serviceId: serviceInfo.serviceId,
          serviceState: serviceInfo.serviceState,
          searchKey: serviceInfo.searchKey,

          errorMessage: serviceInfo.errorMessage,
          errorCode: serviceInfo.errorCode,

          createdAt: serviceInfo.createdAt ? moment(serviceInfo.createdAt).locale('es').format('LLL') : null,
          readyForService: serviceInfo.readyForService ? moment(serviceInfo.readyForService).locale('es').format('LLL') : null,
          readyForBilling: serviceInfo.readyForBilling ? moment(serviceInfo.readyForBilling).locale('es').format('LLL') : null,
          disconnectDate: serviceInfo.disconnectDate ? moment(serviceInfo.disconnectDate).locale('es').format('LLL') : null
        };

        break;
    }
  }

  isArray(obj: any) {
    return Array.isArray(obj);
  }

  returnZero() {
    return 0;
  }

}
